/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://dvxfqmsx5ffzxmibmlt6jndhxq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-on25smj4qjagjkfwboymzes4fm",
    "aws_cognito_identity_pool_id": "us-east-2:8f6d08e9-5ec4-4191-906d-ea451994e4a6",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_ZNmM5F0xp",
    "aws_user_pools_web_client_id": "bgse9v7tthjvj8355gp4rl588",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "dualappbucket211930-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
